/**
 * @generated SignedSource<<f19a107891dd40331b2bf55c3383b023>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useWidgetTodoSubscriptionDeletedSubscription$variables = {
  categoryId: string;
  connections: ReadonlyArray<string>;
  teamIds: ReadonlyArray<string>;
};
export type useWidgetTodoSubscriptionDeletedSubscription$data = {
  readonly todoDeleted: {
    readonly id: string;
  } | null;
};
export type useWidgetTodoSubscriptionDeletedSubscription = {
  response: useWidgetTodoSubscriptionDeletedSubscription$data;
  variables: useWidgetTodoSubscriptionDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v3 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "categoryIds.0",
        "variableName": "categoryId"
      }
    ],
    "kind": "ListValue",
    "name": "categoryIds"
  },
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTodoSubscriptionDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWidgetTodoSubscriptionDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01af5e3f98328546b9b0cfcc3209e894",
    "id": null,
    "metadata": {},
    "name": "useWidgetTodoSubscriptionDeletedSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTodoSubscriptionDeletedSubscription(\n  $categoryId: ID!\n  $teamIds: [ID!]!\n) {\n  todoDeleted(categoryIds: [$categoryId], teamIds: $teamIds) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "28885210c2a1049293be8db23e7cd4ec";

export default node;
